export default __webpack_public_path__ + "static/media/565.bb8fa155.gif";